import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//----- store
import { fetchGraphData } from "../../store/donutChart-actions";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import { PieChart } from "react-minimal-pie-chart";

import Styles from "./DonutChart.module.css";

const defaultLabelStyle = {
	fontSize: "5px",
	fontFamily: "sans-serif",
};

const DonutChart = (props) => {
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.uiData.isLoading[5]);

	const donutChartData = useSelector((state) => state.donutChartData);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.dashboard.donutChart;

	// const replaceColorTable = {
	// 	"#85e582": "#21BA45",
	// 	"#d5d5d1": "#d5d5d1",
	// 	"#fb696d": "#DB2828",
	// }

	useEffect(() => {
		dispatch(fetchGraphData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		console.log("donutChartData", donutChartData);
	}, [donutChartData]);

	return (
		<React.Fragment>
			{isLoading && (
				<div style={{ textAlign: "center" }}>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && donutChartData.graphData.length > 0 && (
				<div style={{ display: "flex" }}>
					{isLoading && (
						<div style={{ textAlign: "center" }}>
							<LoadingSpinner />
						</div>
					)}
					<div
						style={{
							width: "50%",
							padding: "0px 0px 20px 40px",
						}}
					>
						<PieChart
							data={donutChartData.graphData}
							startAngle={-90}
							lineWidth={30}
							label={({ dataEntry }) =>
								Math.round(dataEntry.value)
							}
							labelStyle={(index) => ({
								fontSize: "5px",
								fontFamily: "sans-serif",
								fill: "#000",
							})}
							radius={42}
							labelPosition={85}
						/>
					</div>
					<div
						style={{
							width: "50%",
							padding: "0px 40px 20px 40px",
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							color: "#000",
						}}
					>
						{donutChartData.graphData.map((item) => (
							<div
								style={{
									display: "flex",
									alignItems: "center",
									padding: "5px 0px",
								}}
							>
								<div
									style={{
										width: "12px",
										height: "12px",
										borderRadius: "14px",
										// backgroundColor: item.color,
										// backgroundColor: replaceColorTable[item.color] + " !important",
									}}
								></div>
								<div style={{ paddingLeft: "10px" }}>
									{item.title}
								</div>
							</div>
						))}
					</div>
				</div>
			)}
			{donutChartData.graphData.length == 0 && (
					<div className={Styles["no-record-found"]}>
						Não existem dados sobre as inscrições
					</div>
				)}
		</React.Fragment>
	);
};

export default DonutChart;
